import { configureStore } from "@reduxjs/toolkit";
import jobsReducer from "../features/jobsFinder/jobsFinderSlice";

export const store = configureStore({
  reducer: {
    jobs: jobsReducer,
  },
});
